import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import Autocomplete from '../../../Shared/AutoCompleteInput/AutoCompleteInput.js';
import TextInput from '../../../Shared/TextInput/TextInput';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import { regexPatterns } from '../../../../utilities/validation/validationVariables';
import ProviderManager from '../../../../provider/providerManager';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import DisclaimerIcon from '../Assets/DisclaimerIcon.svg';
import Property from '@episerver/spa-core/Components/Property';
import { ePages } from '../Constants';
import { goToPage, setAddressValues, reportDWH } from '../StandAlonePurchaseSaleSlice';
import EpiContext from '@episerver/spa-core/Spa';

const DeliveryPage = (props) => {
  const [cities, setCities] = useState([]);
  const [streets, setStreets] = useState([]);
  const [address, setAddress] = useState({
    city: { value: '', code: '', semel: '', error: '' },
    street: { value: '', code: '', semel: '', error: '' },
    home: { value: '', error: '' },
    floor: { value: '', error: '' },
    apartment: { value: '', error: '' },
    entry: { value: '', error: '' },
    phone: { value: '', error: '' },
    email: { value: '', error: '' },
    zipCode: { value: '' },
  });
  const [isCityWithoutStreets, setIsCityWithoutStreets] = useState(false);
  const [currentFocus, setCurrentFocus] = useState('city');
  const cityRef = useRef();
  const streetRef = useRef();
  const homeRef = useRef();
  const apartmentRef = useRef();
  const floorRef = useRef();
  const phoneRef = useRef();
  const emailRef = useRef();
  const isDeliveryFree =
    props.deliveryCost === '' ||
    props.deliveryCost === '0' ||
    parseInt(props.productQuantity) >= parseInt(props.minQuantityForFreeDelivery);

  useEffect(() => {
    (async function getCities() {
      props.showAppLoader();
      const result = await ProviderManager.getProviderData('getCities', []);
      props.hideAppLoader();
      if (result.errorCode == undefined) {
        setCities(result.Body);
      }
    })();
    return () => { };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  async function citySelectedChange(cityCode) {
    const selectedCity = cities.find((x) => x.cityCode === cityCode);
    if (selectedCity) {
      address.city = { value: selectedCity.cityName, code: cityCode, semel: selectedCity.citySemel, error: '' };
      address.street = { value: '', code: '', semel: '', error: '' };
      address.home = { value: '', error: '' };
      address.apartment = { value: '', error: '' };
      address.floor = { value: '', error: '' };
      address.entry = { value: '', error: '' };
      setAddress({ ...address });
      setCurrentFocus('street');
      streetRef?.current?.onChange({ currentTarget: { value: '' } });
      getStreets(selectedCity.cityCode, selectedCity.cityName);
    } else {
      address.city = { value: '', code: '', semel: '', error: 'יש לבחור יישוב' };
      setAddress({ ...address });
    }
  }
  async function getStreets(cityCode, cityName) {
    const result = await ProviderManager.getProviderData('getStreetsByCity', [cityCode]);
    const streets = result.Body;
    setStreets(streets);

    if (streets.length == 0) {
      setIsCityWithoutStreets(true);
      address.street = { value: cityName, code: '0', semel: '', error: '' };
      address.home = { value: '0', error: '' };
    } else {
      setIsCityWithoutStreets(false);
      address.street = {value: '', code: '', semel: '', error: '' };
    }
    setAddress({ ...address });
  }

  function streetSelectedChange(streetCode) {
    const selectedStreet = streets.find((x) => x.streetCode === streetCode);
    address.home = { value: '', error: '' };
    address.apartment = { value: '', error: '' };
    address.floor = { value: '', error: '' };
    address.entry = { value: '', error: '' };

    if (selectedStreet) {
      address.street = { value: selectedStreet.streetName, code: selectedStreet.streetCode, semel: selectedStreet.streetSemel, error: '' };
      setCurrentFocus('home');
    } else {
      address.street = { value: '', code: '', semel: '', error: 'יש לבחור רחוב' };
    }
    setAddress({ ...address });
  }

  function homeChange(home) {
    let error = '';

    if (home !== '') {
      error = parseInt(home) < 0 || parseInt(home) > 1000 ? 'שדה לא תקין' : '';
    } else {
      error = 'שדה חובה';
    }
    setAddress({ ...address, home: { value: home, error } });
  }

  function phoneChange(phone) {
    let regex = new RegExp(regexPatterns.phoneRegex);
    var test = regex.test(String(phone).toLowerCase());
    let error = '';

    if (phone !== '') {
      error = test ? '' : 'יש להזין מספר נייד תקין';
    } else {
      error = 'יש להזין מספר נייד';
    }

    setAddress({ ...address, phone: { value: phone, error } });
  }

  function emailChange(email) {
    let regex = new RegExp(regexPatterns.emailRegex);
    var test = regex.test(String(email).toLowerCase());
    let error = '';

    if (email !== '') {
      error = test ? '' : 'יש להזין כתובת מייל תקנית';
    } else {
      error = 'יש להזין כתובת מייל';
    }

    setAddress({ ...address, email: { value: email, error } });
  }

  function apartmentChange(apartment) {
    let error = '';
    if (apartment !== '') {
      error = parseInt(apartment) < 0 || parseInt(apartment) > 100 * (parseInt(address.floor.value) + 1) ? 'שדה לא תקין' : '';
    }

    setAddress({ ...address, apartment: { value: apartment, error } });
  }

  function floorChange(floor) {
    let error = '';

    if (floor !== '') {
      error = parseInt(floor) < 0 || parseInt(floor) > 100 ? 'שדה לא תקין' : '';
    }

    setAddress({ ...address, floor: { value: floor, error } });
  }

  function handleKeyDown(e, field) {
    if (e.key === 'Enter') {
      switch (field) {
        case 'city':
          setCurrentFocus('street');
          break;
        case 'street':
          setCurrentFocus('home');
          break;
        case 'home':
          setCurrentFocus('floor');
          break;
        case 'floor':
          setCurrentFocus('apartment');
          break;
        case 'apartment':
          setCurrentFocus('phone');
          break;
        case 'phone':
          setCurrentFocus('email');
          break;
        default:
          break;
      }
    }
  }

  useEffect(() => {
    switch (currentFocus) {
      case 'street':
        if (streetRef.current) streetRef.current.autoCompleteRef.current.focus();
        break;
      case 'home':
        if (homeRef.current) homeRef.current.focus();
        break;
      case 'floor':
        if (floorRef.current) floorRef.current.focus();
        break;
      case 'apartment':
        if (apartmentRef.current) apartmentRef.current.focus();
        break;
      case 'phone':
        if (phoneRef.current) phoneRef.current.focus();
        break;
      case 'email':
        if (emailRef.current) emailRef.current.focus();
        break;
    }
  }, [currentFocus]);

  async function handleSubmitBtn() {
    if (isFromValid()) {
      props.reportDWH({
        actionType: 'Delivery Address Page Btn Click',
        statusText: 'Ongoing',
        messageText: 'Go to Delivery Date Page',
        param3: address.email.value,
      });

      props.showAppLoader();
      await getZipCode();

      const response = {
        cityCode: address.city.code,
        cityName: address.city.value,
        streetCode: address.street.code,
        streetName: address.street.value,
        floor: address.street.floor,
        home: address.home.value,
        entry: ' ',
        apartment: address.apartment.value,
        phone: address.phone.value,
        email: address.email.value,
        zipCode: address.zipCode.value,
        isValid: true,
      };

      props.setAddressValues(response);
      props.goToPage({ page: ePages.TECHNICIAN_SLOTS_PAGE, percent: '60' });
      props.hideAppLoader();
    }
  }

  async function getZipCode() {
    let zipCodeResult = '';
    try {
      zipCodeResult = await ProviderManager.getProviderData('getZipCode', [address.street.semel, address.city.semel, address.home.value, 'no_entrance']);
    } catch (e) {
      console.log(`@@@ getZipCode Exception => ${e.message}`);
    }
    address.zipCode = { value: zipCodeResult?.Body ?? '' };
    setAddress({ ...address });
  }

  const isFromValid = () => {
    let isValidCount = 0;
    if (!address.city.value) {
      address.city.error = 'יש לבחור יישוב';
      setAddress({ ...address });
    }
    if (!address.street.value) {
      isValidCount++;
      address.street.error = 'יש לבחור רחוב';
      setAddress({ ...address });
    }
    if (address.home.value == '' || parseInt(address.home.value) > 1000) {
      isValidCount++;
      address.home.error = parseInt(address.home.value) > 1000 ? 'שדה לא תקין' : 'שדה חובה';
      setAddress({ ...address });
    }
    if (address.floor.value !== '' && (parseInt(address.floor.value) > 100 || parseInt(address.floor.value) < 0)) {
      isValidCount++;
      address.floor.error = 'שדה לא תקין';
      setAddress({ ...address });
    }
    if (address.floor.value !== '' && parseInt(address.apartment.value) > 100 * (parseInt(address.floor.value) + 1)) {
      isValidCount++;
      address.apartment.error = 'שדה לא תקין';
      setAddress({ ...address });
    }
    if (address.phone.value == '') {
      isValidCount++;
      address.phone.error = 'יש להזין מספר נייד';
      setAddress({ ...address });
    } else {
      let regex = new RegExp(regexPatterns.phoneRegex);
      var test = regex.test(String(address.phone.value).toLowerCase());
      isValidCount = test ? isValidCount : isValidCount + 1;
      address.phone.error = test ? '' : 'יש להזין מספר נייד תקין';
      setAddress({ ...address });
    }
    if (address.email.value == '') {
      isValidCount++;
      address.email.error = 'יש להזין כתובת מייל';
      setAddress({ ...address });
    } else {
      let regex = new RegExp(regexPatterns.emailRegex);
      var test = regex.test(String(address.email.value).toLowerCase());
      isValidCount = test ? isValidCount : isValidCount + 1;
      address.email.error = test ? '' : 'יש להזין כתובת מייל תקנית';
      setAddress({ ...address });
    }

    return isValidCount === 0;
  };

  function onClickServiceCenters() {
    props.reportDWH({
      actionType: 'Selfpicking Link Clicked',
      statusText: 'Completed',
      messageText: 'Selfpicking Link Clicked',
    });
    EpiContext.navigateTo(props.deliveryOtherServiceCentersLink);
  }

  return (
    <div className='delivery-page'>
      <Property className='delivery-page__title' context={props.context} iContent={props.iContent} field='deliveryPageTitle' />
      <div className='delivery-page__form'>
        <div className='delivery-page__form-headline'>
          <span>שליחות</span>
          {!isDeliveryFree ? (
            <div className='delivery-page__cost-holder'>
              <span className='delivery-page__cost'>{props.deliveryCost}&#8362;</span>
              <span className='delivery-page__text-under-cost'>{props.textUnderDeliveryCost}</span>
            </div>
          ) : (
            <span className='delivery-page__cost'>ללא עלות</span>
          )}
        </div>
        <Property className='delivery-page__sub-title' context={props.context} iContent={props.iContent} field='deliveryPageSubTitle' />
        <div className='delivery-page__form-fields'>
          <Autocomplete
            ref={cityRef}
            autofocus={true}
            error={address.city.error}
            value={address.city.value}
            id='city'
            name='city'
            onSelectedChange={(e) => citySelectedChange(e.target.value)}
            suggestions={cities}
            dataKey='cityCode'
            dataValue='cityName'
            placeholder='עיר'
            required='required'
            onKeyDown={(e) => handleKeyDown(e, 'city')}
          />
          {isCityWithoutStreets ? (
            <TextInput
              value={address.street.value}
              placeholder='רחוב'
              id='dummyStreet'
              name='dummyStreet'
              type='text'
              disabled={'disabled'}
              maxLength='10'
              autoComplete='off'
              required='required'
            />
          ) : (
            <Autocomplete
              ref={streetRef}
              error={address.street.error}
              value={address.street.value}
              id='street'
              name='street'
              disabled={address.city.value != '' ? '' : 'disabled'}
              onSelectedChange={(e) => streetSelectedChange(e.target.value)}
              suggestions={streets}
              dataKey='streetCode'
              dataValue='streetName'
              placeholder='רחוב'
              required='required'
              onKeyDown={(e) => handleKeyDown(e, 'street')}
            />
          )}
          <div className='delivery-page__form-apartment-holder'>
            <TextInput
              ref={homeRef}
              value={address.home.value}
              error={address.home.error}
              placeholder='בית'
              id='home'
              name='home'
              maxLength='4'
              disabled={!isCityWithoutStreets && address.street.value != '' ? '' : 'disabled'}
              type='number'
              pattern='[0-9]*'
              autoComplete='off'
              onChange={(e) => homeChange(e.target.value)}
              required='required'
              onKeyDown={(e) => handleKeyDown(e, 'home')}
            />
            <TextInput
              ref={apartmentRef}
              value={address.apartment.value}
              error={address.apartment.error}
              placeholder='דירה'
              id='apartment'
              name='apartment'
              maxLength='4'
              disabled={!isCityWithoutStreets && address.home.value !== '' ? '' : 'disabled'}
              type='number'
              pattern='[0-9]*'
              autoComplete='off'
              onChange={(e) => apartmentChange(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, 'apartment')}
            />
            <TextInput
              ref={floorRef}
              value={address.floor.value}
              error={address.floor.error}
              placeholder='קומה'
              id='floor'
              name='floor'
              maxLength='4'
              disabled={!isCityWithoutStreets && address.home.value !== '' ? '' : 'disabled'}
              type='number'
              pattern='[0-9]*'
              autoComplete='off'
              onChange={(e) => floorChange(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, 'floor')}
            />
          </div>
          <div>
            <TextInput
              ref={phoneRef}
              value={address.phone.value}
              error={address.phone.error}
              placeholder='מספר נייד'
              id='phone'
              name='phone'
              maxLength='10'
              type='number'
              pattern='[0-9]*'
              autoComplete='off'
              onChange={(e) => phoneChange(e.target.value)}
              required='required'
              onKeyDown={(e) => handleKeyDown(e, 'phone')}
            />
            <p className='delivery-page__side-note'>למספר נייד הזה נתקשר שהשליח יהיה בדרך</p>
          </div>
          <div>
            <TextInput
              ref={emailRef}
              value={address.email.value}
              error={address.email.error}
              placeholder='מייל'
              id='email'
              name='email'
              type='email'
              onChange={(e) => emailChange(e.target.value)}
              required='required'
              onKeyDown={(e) => handleKeyDown(e, 'email')}
            />
            <p className='delivery-page__side-note'>למייל הזה נשלח את אישור העסקה</p>
          </div>
        </div>
      </div>
      <div className='delivery-page__footer'>
        <div className='delivery-page__disclaimer-holder'>
          {props.deliveryDisclaimers.map((dcl) => {
            return (
              <div className='delivery-page__disclaimer'>
                <Image className='delivery-page__disclaimer-icon' src={DisclaimerIcon} alt='' />
                <span>{dcl}</span>
              </div>
            );
          })}
        </div>
        <div className='delivery-page__btn-wrap'>
          <BtnSubmit
            className='delivery-page__btn'
            text={props.deliveryButtonText === '' ? 'בחירת מועד' : props.deliveryButtonText}
            onclick={() => handleSubmitBtn()}
          />
        </div>
        <div className='delivery-page__holder-column'>
          <span>אפשר גם לאסוף עצמאית</span>
          <span className='delivery-page__other-services-link' onClick={() => onClickServiceCenters()}>
            באחד ממרכזי השירות שלנו
          </span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    iContent: state.standAlonePurchaseSaleBlock?.epiContent?.iContent,
    deliveryCost: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.deliveryCost?.value ?? '',
    deliveryOtherServiceCentersLink:
      state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.deliveryOtherServiceCentersLink.value?.url ?? '',
    textUnderDeliveryCost: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.deliveryTextUnderDeliveryCost?.value ?? '',
    deliveryButtonText: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.deliveryButtonText?.value ?? '',
    deliveryDisclaimers: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.deliveryDisclaimers?.value ?? [],
    form: state.standAlonePurchaseSaleBlock?.form,
    productQuantity: state.standAlonePurchaseSaleBlock?.productQuantity,
    minQuantityForFreeDelivery:
      state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productMinQuantityForCancellingDeliveryCost.value ?? '',

    otpPhone: state.authentication?.loginData?.userDetails?.contactNumber ?? '',
  };
};

const mapDispatchToProps = {
  setAddressValues,
  goToPage,
  showAppLoader,
  hideAppLoader,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryPage);
